import { NotificationsPage } from '@/features/city-clerk/notification'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/city-clerk/$id/notification')({
  component: NotificationPage,
})

function NotificationPage() {
  return <NotificationsPage />
}
